<template>
  <div class="crud-services-category">
    <b-card body-class="py-2">
      <section class="list-view-heading">
        <ModuleViewHeading :module-id="access.module_id" :profile-id="access.profile_id" :reference="access.view_reference" summary-only />
        <div class="list-view-heading__controls">
          <div class="list-view-heading__actions"><TabHeaderActions /></div>
          <div class="list-view-heading__controls-end">
            <b-button variant="link" class="list-view-icon-btn" :class="{ 'list-view-icon-btn--active': filtersOpen }" v-b-tooltip.hover.bottom :title="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'" :aria-label="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'" @click="filtersOpen = !filtersOpen"><AppIcon name="filter" :fill="filtersOpen" /></b-button>
            <b-button @click="add" type="button" variant="link" class="list-view-icon-btn list-view-icon-btn--primary" v-b-tooltip.hover.bottom title="Agregar categoría" aria-label="Agregar categoría"><AppIcon name="add" /></b-button>
          </div>
        </div>
      </section>
      <b-collapse v-model="filtersOpen">
        <div class="list-view-toolbar__filters">
          <div class="list-view-filter" style="width: 260px;"><label class="filter-label">Buscar</label><b-input-group size="sm"><b-form-input type="text" placeholder="Nombre de categoría" v-model="table.filter" /><b-input-group-append><b-button variant="outline-dark" :disabled="!table.filter" @click="table.filter = ''" v-b-tooltip.hover title="Limpiar búsqueda"><AppIcon name="x" /></b-button></b-input-group-append></b-input-group></div>
        </div>
      </b-collapse>
    </b-card>

    <b-card no-body class="mt-2">
      <b-table v-if="table.items.length" class="mb-0 app-table" responsive sticky-header="60vh" :stacked="isMobileViewport ? 'md' : false" :fixed="!isMobileViewport" :hover="true" :items="table.items" :fields="table.fields" :filter="table.filter" :current-page="table.currentPage" :per-page="table.perPage">
        <template v-slot:table-colgroup="scope"><col v-for="field in scope.fields" :key="field.key" :style="{ width: field.width }"></template>
        <template v-slot:cell(id)="data"><b>{{data.item.id}}</b></template>
        <template v-slot:cell(name)="data"><b>{{data.item.name}}</b></template>
        <template v-slot:cell(f_action)="data">
          <b-dropdown right no-caret size="sm" variant="link" boundary="window" :toggle-class="isMobileViewport ? 'crud-services-category-action-toggle' : 'app-table-action-toggle'" :class="{ 'pull-right': !isMobileViewport }">
            <template #button-content><AppIcon name="more_vert" :class="{ 'mr-1': isMobileViewport }" /><span v-if="isMobileViewport">Opciones</span></template>
            <b-dropdown-item @click="edit(data.item)"><AppIcon name="edit" class="mr-1" /> Editar</b-dropdown-item>
            <b-dropdown-item @click="remove(data.item)"><AppIcon name="delete" class="mr-1 text-danger" /> Eliminar</b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
      <EmptyState v-else icon="category" title="No se encontraron categorías" />
      <div class="app-table-footer crud-services-category-table-footer" v-if="table.items.length"><span>{{ getRowCount(table.items) }} registros</span></div>
    </b-card>

    <b-card body-class="py-2" class="mt-2">
      <div class="list-view-footer">
        <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)"><AppIcon name="back" class="mr-1" /> Volver</b-button>
        <nav><b-pagination class="mb-0" size="sm" pills :total-rows="getRowCount(table.items)" :per-page="table.perPage" v-model="table.currentPage" /></nav>
      </div>
    </b-card>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.form.active"
              :key="modal.form._id"
              :id="modal.form._id">                  
        <template #modal-header><div class="app-modal-header"><span class="app-modal-header__icon"><AppIcon :name="crud.form.id ? 'edit' : 'add'" /></span><h5 class="app-modal-header__title">{{ modal.form.title }}</h5></div></template>

        <b-row>
          <b-col md="12">
            <b-form-group label="Nombre">
              <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.name"
                            required
                            placeholder="Ingresar un nombre">
              </b-form-input>
            </b-form-group>
          </b-col>         
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="save()"><AppIcon name="save" class="mr-1" /> Guardar</b-button>
        </div>
      </b-modal>

  </div>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper' 
  import Storage from '@/handler/storageLocal'
  import ModuleViewHeading from '@/components/inc/module/ModuleViewHeading'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  export default {
    components: {
      ModuleViewHeading,
      TabHeaderActions,
    },      
    data: () => {
      return {      
        access: {
          module_id: Modules.SERVICIOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudCategory',
          elements: {}
        }, 
        table : {
          items: [],
          fields: [],
          filter: null,
          currentPage: 1,
          perPage: 50,
        },   
        crud: {
          form: {
            id: 0,
            name: '',            
          },           
        },
        modal: {
          form: {
            active: false,
            title: ''
          },             
        },
        filtersOpen: false,
        isMobileViewport: false,
        mobileMql: null,
      }
    },
    created () {     
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },  
    mounted() {
      this.filtersOpen = Storage.getValue('filters_open_services_categories') == 'true'
      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)
      this.loadFieldTable()
      this.load()
    },
    beforeDestroy() {
      if(this.mobileMql) this.mobileMql.removeEventListener('change', this.updateMobileViewport)
    },
    watch: {
      filtersOpen(value) {
        Storage.setValue('filters_open_services_categories', value ? 'true' : 'false')
      }
    },
    methods: {
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
        this.loadFieldTable()
      },
      loadFieldTable() {
        this.table.fields = [
          {key: 'id', label: 'ID', sortable: true, class: 'align-middle ' + (this.isMobileViewport ? 'text-left' : 'text-center'), width: '4%'},
          {key: 'name', label: 'Nombre', class: 'align-middle text-left', width: '92%'},
          {key: 'f_action', label: this.isMobileViewport ? 'Acción' : '', class: 'align-middle text-left', width: '4%'},
        ]
      },
      getRowCount (items) {
        return items.length
      },    
      load() {
        var result = serviceAPI.obtenerCategory()

        result.then((response) => {
          var data = response.data
          this.table.items = data                    
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        });        
      },
      add() {
        this.crud.form.id = 0
        this.crud.form.name = '' 
        
        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Nueva Categoría"
        this.modal.form.active = true
      },
      edit(item) {
        this.crud.form.id = item.id
        this.crud.form.name = item.name           
        
        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Editar Categoría"
        this.modal.form.active = true
      },
      remove(item) {
        this.crud.form.id = item.id
        this.crud.form.name = item.name        

        this.confirmDialog('¿Desea eliminar la categoría “' + this.crud.form.name + '”?', {
          title: 'Eliminar categoría',
          icon: 'delete',
          danger: true,
          okTitle: 'Eliminar'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarCategory(this.crud.form.id);

            result.then((response) => {      
              this.modal.form.active = false        
              loader.hide()
              this.load()
              this.$awn.success("Registro eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },
      save() {
        let loader = this.$loading.show();
        if (this.crud.form.id) {
          var result = serviceAPI.editarCategory(this.crud.form);
        } else {
          var result = serviceAPI.agregarCategory(this.crud.form);
        }

        result.then((response) => {
          this.modal.form.active = false
          loader.hide()
          this.load()
          this.$awn.success("Datos guardados con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },   
    }    
  }
</script>
<style scoped>
  .btn.crud-services-category-action-toggle { align-items: center; background: transparent !important; border: none !important; box-shadow: none !important; color: var(--app-color-text-secondary) !important; display: inline-flex !important; font-size: var(--app-text-sm); padding: 0 !important; }
  .crud-services-category-table-footer { padding-right: 12px; }
</style>
